import React from 'react';
import { ContentSwitch } from 'Components';
import PropTypes from 'prop-types';
import FooterDesktop from './FooterDesktop/FooterDesktop';
import FooterMobile from './FooterMobile/FooterMobile';

const Footer = props => (
  <ContentSwitch index={props.deviceIndex} >
    <FooterMobile />
    <FooterDesktop footerDesktopExpanded={props.footerDesktopExpanded} />
  </ContentSwitch>
);

Footer.propTypes = {
  deviceIndex: PropTypes.number,
  footerDesktopExpanded: PropTypes.bool,
};

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer/Footer.jsx